/*
 * The set name under the product title.
 *
 * The name is printed by the variant_label custom_liquid block of
 * templates/product.discovery-set.json, from
 * product.selected_or_first_available_variant.title.
 *
 * Dawn re-renders only price, SKU, inventory, volume and price-per-item after
 * a variant change (assets/product-info.js, handleUpdateProductInfo calls
 * updateSourceFromDestination on exactly those five ids). A custom_liquid
 * block is not in that list, so the line keeps whatever the server printed on
 * first load: pick Midnight and it still reads Daylight.
 *
 * The selected variant is read from variant-selects' own data-selected-variant
 * script rather than the checked radio, because Dawn replaces that whole
 * element with the fetched markup, so the JSON is always the new variant and
 * carries the full title for a multi-option product without joining anything.
 *
 * Watched with an observer rather than a change listener because the variant
 * change travels through Dawn's pubsub, which an external script cannot
 * subscribe to. Same approach as resemble-atc-price.js.
 */
(function () {
  'use strict';

  function selectedTitle(scope) {
    var node = scope.querySelector('variant-selects [data-selected-variant]');
    if (!node) return '';

    try {
      var variant = JSON.parse(node.textContent);
      return variant && variant.title ? variant.title : '';
    } catch (error) {
      return '';
    }
  }

  function stamp() {
    var infos = document.querySelectorAll('product-info');

    for (var i = 0; i < infos.length; i += 1) {
      var label = infos[i].querySelector('.resemble-product__variant-label');
      if (!label) continue;

      var title = selectedTitle(infos[i]);

      /* No title means an unavailable combination, where Dawn leaves the
         variant null. Keeping the last good name beats blanking the line. */
      if (!title || title === 'Default Title') continue;

      /* Only write when it actually changed, otherwise the observer below
         would retrigger on its own mutation. */
      if (label.textContent !== title) label.textContent = title;
    }
  }

  function watch() {
    stamp();

    if (typeof MutationObserver === 'undefined') return;

    var infos = document.querySelectorAll('product-info');
    for (var i = 0; i < infos.length; i += 1) {
      new MutationObserver(stamp).observe(infos[i], {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
